"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const malty_atoms_icon_1 = require("@carlsberggroup/malty.atoms.icon");
const malty_atoms_text_1 = require("@carlsberggroup/malty.atoms.text");
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const Checkbox_styled_1 = require("./Checkbox.styled");
const Checkbox = (_a) => {
    var { id, value = '', checked = false, labelText, error, required = false, dataTestId, isIndeterminate, readOnly, disabled, fullWidth, onValueChange } = _a, props = __rest(_a, ["id", "value", "checked", "labelText", "error", "required", "dataTestId", "isIndeterminate", "readOnly", "disabled", "fullWidth", "onValueChange"]);
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    const getIconName = () => {
        if (checked) {
            return malty_atoms_icon_1.IconName.CheckboxCheck;
        }
        if (isIndeterminate) {
            return malty_atoms_icon_1.IconName.CheckboxCheckAlternate;
        }
        return malty_atoms_icon_1.IconName.CheckboxEmpty;
    };
    const getTextColor = () => {
        if (disabled) {
            return malty_atoms_text_1.TextColor.DisableLightTheme;
        }
        if (readOnly) {
            return malty_atoms_text_1.TextColor.Support80;
        }
        return malty_atoms_text_1.TextColor.DigitalBlack;
    };
    const getIconColor = () => {
        if (disabled) {
            return malty_atoms_icon_1.IconColor.DisableLight;
        }
        if (readOnly) {
            return malty_atoms_icon_1.IconColor.Support80;
        }
        return malty_atoms_icon_1.IconColor.DigitalBlack;
    };
    return (react_1.default.createElement(Checkbox_styled_1.StyledCheckboxContainer, { fullWidth: fullWidth },
        react_1.default.createElement(Checkbox_styled_1.StyledLabel, { htmlFor: id, disabled: readOnly || disabled, required: required, theme: theme },
            react_1.default.createElement(Checkbox_styled_1.StyledSpan, { theme: theme },
                react_1.default.createElement(Checkbox_styled_1.StyledInput, Object.assign({ type: "checkbox", id: id, "data-testid": dataTestId, value: value, checked: checked, disabled: readOnly || disabled, onChange: onValueChange }, props)),
                react_1.default.createElement(malty_atoms_icon_1.Icon, { name: getIconName(), color: getIconColor(), size: malty_atoms_icon_1.IconSize.Medium })),
            labelText ? (react_1.default.createElement(Checkbox_styled_1.StyledText, { textStyle: malty_atoms_text_1.TextStyle.MediumSmallDefault, color: getTextColor(), "data-testid": `${dataTestId}-label`, theme: theme }, labelText)) : null),
        error && (react_1.default.createElement(Checkbox_styled_1.StyledError, { textStyle: malty_atoms_text_1.TextStyle.SmallBold, color: malty_atoms_text_1.TextColor.Fail, theme: theme }, error))));
};
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map